import Firebase from 'firebase';
import EventEmitter from 'events';

class CatRepository extends EventEmitter {

  constructor() {
    super();
    this.ref = new Firebase('https://uniquitty-10845.firebaseio.com/cats');
    this.attachFirebaseListeners();
    this.sortOrder = 'common';
  }

  attachFirebaseListeners () {
   this.ref.orderByChild('number').on('child_added', this.onAdded, this)
   this.ref.on('child_removed', this.onRemoved, this)
   this.ref.orderByChild('number').on('child_changed', this.onChanged, this)
 }

  sortByUnique(){
    this.sortOrder = 'unique';
  }

  sortByCommon(){
    this.sortOrder = 'common';
  }

  getSortOrder() {
    return this.sortOrder;
  }

  create({ name = ''}, onComplete) {
    this.ref.child(name).set({
      number: 1
    });
  }

  update({ snapshot = '', name = '' }, onComplete) {
    const newNumber = snapshot.val().number + 1;
    const newObj = {
      number: newNumber,
    };
    this.ref.child(name).set(newObj);
  }

  onAdded (snapshot) {
    let cat = this.snapshotToCat(snapshot)
    this.emit('added', cat)
  }

  onRemoved (oldSnapshot) {
    let cat = this.snapshotToCat(oldSnapshot)
    this.emit('removed', cat)
  }

  onChanged (snapshot) {
    let cat = this.snapshotToCat(snapshot)
    this.emit('changed', cat)
  }

  snapshotToCat (snapshot) {
    let key = snapshot.key()
    let cat = snapshot.val()
    cat.key = key;
    return cat
  }

  findIndex (cats, key) {
    return cats.findIndex(note => note.key === key)
  }

  find (cats, key) {
    return cats.find(note => note.key === key)
  }

  //TODO Tidy this shit up
  regrabItems(){
    this.ref.orderByChild('number').once('value', (snapshot) => {

      var data = snapshot.val();
      var done = Object.keys(data).map(function(key) {
          var object = {
            number: data[key].number,
            key: key
          };
          return object;
      });

      if (this.sortOrder === 'common'){
        done = done.sort((a,b) => {
          return a.number - b.number
        });
      } else {
        done = done.sort((a,b) => {
          return b.number - a.number
        });
      }

      done.map(e => {
        this.emit('added', e);
      })
    });
  }
}

export default new CatRepository();



// WEBPACK FOOTER //
// ./src/data/CatRepository.js